import React from 'react';
import { createSearchParams, Link, useLocation } from 'react-router-dom';
import { Grid, Icon, Popup } from 'semantic-ui-react'
import { ClippedContent, USER_PERMISSIONS } from 'dyl-components';
import { StringUtils } from 'utils';
import RestrictedView from 'shared/RestrictedView';

const ModuleLink = ({ pipeline_id, includeLabel, idWidth = 8, unlinked, record, isLeadConnect }) => {
    const location = useLocation();
    return (
        <Grid columns={'equal'}>
            <Grid.Column width={idWidth} style={{ display: "flex", alignItems: "center" }}>
                {isLeadConnect && <Icon  className='fas fa-file-user' color="blue" />}
                <ClippedContent popup={!unlinked} popupContent={!unlinked ? pipeline_id : ""}>

                    {includeLabel && 'ID: '}
                    {unlinked ? "Moved" : (
                        <RestrictedView type="link" userPermission={record?.contact?.module_summary?.account_stage === "opportunity" ? USER_PERMISSIONS.OPPORTUNITY_VIEW : USER_PERMISSIONS.LEAD_VIEW} userRestrict assignmentIds={[record?.contact?.owner_id  || record?.contact?.assignees?.owner_id || 0, record?.contact?.coowner_id || record?.contact?.assignees?.coowner_id || 0]}>
                            <Link to={{
                                pathname: location.pathname,
                                search: createSearchParams({
                                    ...Object.fromEntries(new URLSearchParams(location.search)),
                                    module_id: pipeline_id
                                }).toString()

                            }} state={{ isTogglingPanel: true }}>
                                {pipeline_id}
                            </Link>
                        </RestrictedView>
                    )}
                </ClippedContent>
            </Grid.Column>
            <Popup
                trigger={(
                    !unlinked && (
                        <Grid.Column width={1}>
                            <Icon style={{ marginLeft: "-2em" }} link className='fas fa-copy' color="blue" onClick={StringUtils.copy(pipeline_id)} />
                        </Grid.Column>
                    )
                )}
                content='Copied!'
                on='click'
                closeOnTriggerMouseLeave
                inverted
            />
        </Grid>
    );
}

export default ModuleLink;
